import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoginSocialFacebook } from "reactjs-social-login";
import { Mail } from "../../images/icons/JsxIcons";
import fbIcon from "../../images/icons/social/fb.png";
import googleIcon from "../../images/icons/social/google.png";
import { useStorePageManager } from "../../store/PageManage";
import InputPhoneNumber from "../cells/InputPhoneNumber";

export const InscriptionPanelConnexionPart = ({
  currentState = 1,
  panelState,
  setPanelState,
  dataInscription,
  setDataInscription,
  launchAppleLogin,
  launchGoogleLogin,
  facebookLoginVoid,
  refFirstName,
  refLastName,
  refPassword,
}) => {
  const { t } = useTranslation();
  const [stateMail, setStateMail] = useState({
    focus: false,
    error: false,
    good: false,
  });
  const [stateTelephone, setStateTelephone] = useState({
    focus: false,
    error: false,
    good: false,
  });

  const [curentCountrySelected, setCurentCountrySelected] = useState();

  useEffect(() => {
    if (dataInscription.addressMail.length > 0) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(dataInscription.addressMail)) {
        setStateMail({ ...stateMail, error: false, good: true });
      } else {
        setStateMail({ ...stateMail, error: true, good: false });
      }
    } else {
      setStateMail({ ...stateMail, error: false, good: false });
    }
  }, [dataInscription.addressMail]);
  useEffect(() => {
    if (dataInscription.telephone.length > 2) {
      if (dataInscription.telephone.length >= 8) {
        setStateTelephone({ ...stateTelephone, error: false, good: true });
      } else {
        setStateTelephone({ ...stateTelephone, error: true, good: false });
      }
    } else {
      setStateTelephone({ ...stateTelephone, error: false, good: false });
    }
  }, [dataInscription.telephone]);

  const handleUptadeTelephone = (e) => {
    let newTelephone = e.target.value.replace(/[^0-9]/g, "");
    setDataInscription({ ...dataInscription, telephone: newTelephone });
    e.target.value = newTelephone;
  };

  const handleGoToFinishInscription = () => {
    if (stateMail.good && stateTelephone.good && curentCountrySelected) {
      refFirstName.current.value = "";
      refLastName.current.value = "";
      refPassword.current.value = "";
      setPanelState({
        ...panelState,
        inscriptionBegin: 0,
        inscriptionFinish: 1,
      });
    }
  };

  const handleGoToConnexionPanel = () => {
    setDataInscription({
      ...dataInscription,
      naming: "",
      firstName: "",
      addressMail: "",
      telephone: "",
      mdp: "",
    });
    setPanelState({
      ...panelState,
      inscriptionBegin: 0,
      connexion: 1,
    });
  };

  return (
    <div
      className={`contains inscription-part ${
        currentState == 0
          ? "go-left-side"
          : currentState == 1
          ? "come-center"
          : "go-right-side"
      } | flcolm`}
    >
      <label>{t("modals.connexionPanel.inscription.title")}</label>
      <div className="input-field | flcolm">
        <div className="input | rlve">
          <Mail color={stateMail.focus ? "var(--gray-600)" : "none"} />
          <input
            onBlur={() => setStateMail({ ...stateMail, focus: false })}
            onFocus={() => setStateMail({ ...stateMail, focus: true })}
            onChange={(e) =>
              setDataInscription({
                ...dataInscription,
                addressMail: e.target.value,
              })
            }
            autoCorrect="false"
            autoCapitalize="false"
            autoComplete="false"
            placeholder={t("modals.connexionPanel.inscription.champs.mail")}
            type="email"
          />
          {stateMail.focus == false && stateMail.error && (
            <div className="detect-issue-input">
              <div className="chevron"></div>
              <span>
                {t("modals.connexionPanel.inscription.champs.issueMail")}
              </span>
            </div>
          )}
        </div>
        <InputPhoneNumber
          dataInscription={dataInscription}
          setDataInscription={setDataInscription}
          setStateTelephone={setStateTelephone}
          stateTelephone={stateTelephone}
          handleUptadeTelephone={handleUptadeTelephone}
          curentCountrySelected={curentCountrySelected}
          setCurentCountrySelected={setCurentCountrySelected}
        />
      </div>
      <button
        onClick={handleGoToFinishInscription}
        className="next-btn | btn flex"
        disabled={
          !(stateMail.good && stateTelephone.good && curentCountrySelected)
        }
      >
        {t("modals.connexionPanel.inscription.confirmTxt")}
      </button>
      <div className="separator | flrow allcenter">
        <div className="line"></div>
        <span>{t("modals.connexionPanel.inscription.orTxt")}</span>
        <div className="line"></div>
      </div>
      <div className="social-connect | flcolm addgap8">
        <button
          type="button"
          onClick={launchAppleLogin}
          className="google-btn | btn flrow center"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M14.94 10.56c-.02-2.27 1.85-3.36 1.93-3.41-1.05-1.54-2.69-1.75-3.27-1.77-1.39-.14-2.72.82-3.43.82-.71 0-1.81-.8-2.97-.78-1.53.02-2.94.89-3.73 2.26-1.59 2.76-.41 6.85 1.14 9.09.76 1.1 1.66 2.33 2.85 2.28 1.14-.05 1.57-.74 2.95-.74 1.38 0 1.77.74 2.98.71 1.23-.02 2.01-1.12 2.76-2.22.87-1.27 1.23-2.51 1.25-2.57-.03-.01-2.4-.92-2.42-3.67h-.04zM12.67 3.88c.63-.76 1.05-1.82.94-2.88-.91.04-2.01.61-2.66 1.37-.59.68-1.1 1.76-.96 2.8 1.01.08 2.04-.52 2.68-1.29z"
              fill="currentColor"
            />
          </svg>
          <span>{t("modals.connexionPanel.authV2.continueApple")}</span>
        </button>
        <button
          onClick={() => {
            useStorePageManager.getState().handleUpdateBlockScreen(true);
            launchGoogleLogin();
          }}
          className="google-btn | btn flrow center"
        >
          <img src={googleIcon} alt="google-logo" />
          <span>{t("modals.connexionPanel.inscription.social.google")}</span>
        </button>
        <LoginSocialFacebook
          className="fb-login | maxwidth"
          appId={process.env.REACT_APP_CONNEXION_FACEBOOK}
          onLoginStart={() => {
            useStorePageManager.getState().handleUpdateBlockScreen(true);
          }}
          onResolve={(response) => {
            facebookLoginVoid(response);
          }}
          onReject={() => {
            useStorePageManager.getState().handleUpdateBlockScreen(false);
          }}
          onError={() => {
            useStorePageManager.getState().handleUpdateBlockScreen(false);
          }}
        >
          <button type="button" className="fb-btn | btn flrow center">
            <img src={fbIcon} alt="fb-logo" />
            <span>{t("modals.connexionPanel.inscription.social.facebook")}</span>
          </button>
        </LoginSocialFacebook>

        <p className="other-choice">
          {t("modals.connexionPanel.inscription.otherChoice")}{" "}
          <span onClick={handleGoToConnexionPanel}>
            {t("modals.connexionPanel.inscription.connexionTxt")}
          </span>
        </p>
      </div>
    </div>
  );
};
